<template>
  <div>
    <TopBlock
      type="seller"
      :title="$t('common.sellOnOskelly')"
      :subtitle="$t('components.info.sellerPage.subtitle')"
    />

    <AnchorList :list="sellerAnchorList" />

    <WhatIsOskelly />

    <HowTo type="sell" />

    <OskellyExpertise type="sell" />

    <SafeDeal class="safe_deal_buyer" />

    <OskellyCommission />

    <BecomeBoutique />

    <UsefulTips type="sell" />
  </div>
</template>

<script setup lang="ts">
import { sellerAnchorList } from '~/components/info/anchors';

import AnchorList from '~/components/info/AnchorList.vue';
import BecomeBoutique from '~/components/info/BecomeBoutique.vue';
import OskellyCommission from '~/components/info/OskellyCommission.vue';
import OskellyExpertise from '~/components/info/OskellyExpertise.vue';
import SafeDeal from '~/components/info/SafeDeal.vue';
import TopBlock from '~/components/info/TopBlock.vue';
import WhatIsOskelly from '~/components/info/WhatIsOskelly.vue';
import HowTo from '~/components/info/HowTo.vue';
import UsefulTips from '~/components/info/UsefulTips.vue';

const { t } = useI18n();

useHead({
  title: `${t('common.sellOnOskelly')} – ${t('common.OskellyOnlineStore')}`,
  meta: [
    {
      name: 'description',
      content: `${t('common.sellOnOskelly')} – ${t('common.OskellyOnlineStore')}`,
    },
  ],
});
</script>
